import React from 'react';
import styled from '@cthings.co/styled-components';
import { SpinnerClassic } from '../animations/SpinnerClassic';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
`;

export const LoadingScreen = () => {
  return (
    <Wrapper>
      <SpinnerClassic />
    </Wrapper>
  );
};
